<template>
  <stacked-chart
    :color="color"
    :title="title"
    :xAxis="xAxis"
    :data="data"
    :direction="direction"
    :filterFrom="filterFrom"
    :filterTo="filterTo"
    :filterType="filterType"
    :filterViewGroup="filterViewGroup"
  />
</template>
<script>
import apiDashboard from '@/apis/dashboard'
import StackedChart from '@/components/echart/stacked'
import variables from '@/styles/variables.scss'
export default {
  components: {
    StackedChart
  },
  props: {
    clear: Number,
    refresh: Object,
    from: String,
    to: String,
    direction: String
  },
  data() {
    return {
      color:
        this.direction === 'outbound'
          ? [this.$getVoiceOutboundColor[0], variables.grayColor]
          : [this.$getVoiceColor[0], variables.grayColor],
      title: 'Outbound calls',
      xAxis: [],
      data: [
        {
          name: 'Success',
          type: 'bar',
          data: []
        },
        {
          name: 'Not success',
          type: 'bar',
          data: []
        }
      ],
      filterFrom: '',
      filterTo: '',
      filterType: 'voice',
      filterViewGroup: ''
    }
  },
  watch: {
    clear: {
      handler(val) {
        if (val) {
          this.xAxis = []
          this.data[0].data = []
          this.data[1].data = []
          this.filterFrom = ''
          this.filterTo = ''
          this.filterType = 'voice'
          this.filterViewGroup = ''
        }
      }
    },
    refresh: {
      deep: true,
      immediate: true,
      handler(val) {
        this.getVoiceCompareSessionSuccess()
      }
    }
  },
  methods: {
    async getVoiceCompareSessionSuccess() {
      this.xAxis = []
      this.data[0].data = []
      this.data[1].data = []
      this.dataFilter = []
      this.filterFrom = this.from
      this.filterTo = this.to
      this.filterType = 'voice'
      this.filterViewGroup = this.refresh.group

      try {
        const obj = {
          from: this.from,
          to: this.to,
          direction: this.direction,
          view_group: this.refresh.group
        }
        const data = await apiDashboard.getVoiceCompareSessionSuccess(obj)
        for (let i = 0; i < data.data.length; i++) {
          const value = data.data[i]
          this.xAxis.push(value.day)
          this.data[0].data.push(value.success || '-')
          this.data[1].data.push(value.not_success || '-')
        }
      } catch (error) {}
    }
  }
}
</script>
